import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromState from './roomchampions.state';

const { selectIds, selectEntities, selectAll, selectTotal } = fromState.adapter.getSelectors();

export const selectRoomchampionsState = createFeatureSelector<fromState.RoomchampionsState>(fromState.roomchampionsEntityKey);

export const selectRoomchampionsIds = createSelector(
    selectRoomchampionsState,
    selectIds,
);

export const selectRoomchampionsEntities = createSelector(
    selectRoomchampionsState,
    selectEntities,
);

export const selectAllRoomchampionsItemsPresent = createSelector(
    selectRoomchampionsState,
    selectAll,
);

export const selectRoomchampionsItemsPresentCount = createSelector(
    selectRoomchampionsState,
    selectTotal,
);

export const selectRoomchampionsByRoom = (room: string) => createSelector(
    selectAllRoomchampionsItemsPresent,
    (entries: fromState.RoomchampionsEntity[]) => {
        return entries.filter(entry => entry.data)
    });